import Image from 'next/image';
import Link from 'next/link';
import logo from '../../assets/images/logoDark.webp';
import OpenModalWrapper from './OpenModalWrapper/OpenModalWrapper';
import { MODAL_NAMES } from '@/constants/modals';
import styles from './FormFooter.module.scss';

interface Props {
  variant: 'form' | 'offer-wall' | 'offerhub' | 'tri-point';
  showNMLSLink?: boolean;
}

const FormFooter = ({ variant, showNMLSLink = false }: Props) => {
  const footerStyles = `${styles.wrapper} ${styles[variant]}`;

  return (
    <footer className={footerStyles}>
      {variant !== 'offerhub' && (
        <Image alt="logo" priority className={styles.logo} src={logo} />
      )}
      <article className={styles.linksWrapper}>
        <OpenModalWrapper
          name={MODAL_NAMES.technicalTermsOfService}
          label="Terms Of Service"
        />
        <OpenModalWrapper
          name={MODAL_NAMES.technicalPrivacyPolicy}
          label="Privacy Policy"
        />
        <OpenModalWrapper
          name={MODAL_NAMES.advertiserDisclosure}
          label="Ad Disclosure"
        />
        <OpenModalWrapper
          name={MODAL_NAMES.generalDisclosure}
          label="Disclosures"
        />
        {showNMLSLink && (
          <Link
            aria-label="nmls"
            href="https://www.nmlsconsumeraccess.org/"
            target="_blank"
            rel="noreferrer noopener"
            className={styles.link}
          >
            NMLS#1475872
          </Link>
        )}
      </article>
    </footer>
  );
};

export default FormFooter;
